import axios from "axios";

export const readScoreCardById = async (scoreCardId: any) => {
  try {
    let formData = new FormData();

    formData.append("scoreCardId", scoreCardId);
    formData.append("token", "token");

    const { data } = await axios({
      method: "post",
      url: `${process.env.REACT_APP_API_HOST}/api/scoreCard/read_by_id.php`,
      data: formData,
      headers: {
        Accept: "application/json",
      },
    });

    return data;
  } catch (error: any) {
    if (error.response) {
      return error.response.data; // => the response payload
    } else {
      //console.log(error);
    }
  }
};
